import Length from "./Length";
import Rectangle from "./Rectangle";
import Area from "./Area";
import AbstractShape from "./AbstractShape";

export default class Hexagon extends AbstractShape {
	static NAME = "hexagon";

	constructor( side_length ) {
		super();

		this.side_length = side_length;
	}

	get_name() {
		return Hexagon.NAME;
	}

	get_enclosing_rectangle() {
		const side_length = this.side_length.in_mm();
		const long_side   = side_length * 2;
		const short_side  = Math.sqrt( Math.pow( side_length, 2 ) - Math.pow( side_length / 2, 2 ) ) * 2;
		return new Rectangle( new Length( long_side ), new Length( short_side ) );
	}

	get_area() {
		const area = 3 * Math.sqrt( 3 ) / 2 * Math.pow( this.side_length.in_mm(), 2 );
		return new Area( area );
	}

	get_circumference() {
		return new Length( 6 * this.side_length.in_mm() );
	}

	get_side_length() {
		return this.side_length;
	}

	get_maximum_dimensions( maximum_rectangle ) //See https://en.wikipedia.org/wiki/Hexagon#Parameters
	//The shortest side is the d, now we need to calculate R.
	//r = 0.5d
	//r = ( sqrt(3) / 2 ) * R
	//r / ( sqrt(3) / 2 ) = R
	//R = r / ( sqrt(3) / 2 )
	{
		let shortest_side = maximum_rectangle.get_shortest_side().in_mm();
		shortest_side = shortest_side / 2;
		const maximum_side_length = shortest_side / (
			Math.sqrt( 3 ) / 2
		);
		return {
			side_length: new Length( maximum_side_length )
		};
	}

	get_dimension_keys() {
		return [ "side_length" ];
	}

	get_modifier_keys() {
		return [];
	}

	serialize_primitives() {
		return {
			side_length: this.side_length
		};
	}

	static deserialize_primitives( primitives ) {
		return new Hexagon( new Length( primitives.side_length ) );
	}
}
